import { IRoutesProps } from "types";
import activeDashboard from "assets/icons/dashboard-active.svg";
import inactiveDashboard from "assets/icons/dashboard-inactive.svg";
import activeVaccination from "assets/icons/vaccine-active.svg";
import inactiveVaccination from "assets/icons/vaccine-inactive.svg";
import activedownload from "assets/icons/download-active.svg";
import inactivedownload from "assets/icons/download-inactive.svg";
import activeReminder from "assets/icons/reminder-active.svg";
import inactiveReminder from "assets/icons/reminder-inactive.svg";
import activeCalender from "assets/icons/calendar-active.svg";
import inactiveCalender from "assets/icons/calendar-inactive.svg";
import activeWallet from "assets/icons/wallet-active.svg";
import inactiveWallet from "assets/icons/wallet-inactive.svg";
import activeRecommendation from "assets/icons/recommendation-active.svg";
import inactiveRecommendation from "assets/icons/recommendation-inactive.svg";
import activeFamily from "assets/icons/family-active.svg";
import inactiveFamily from "assets/icons/family-inactive.svg";
import inactiveSettings from "assets/icons/settings-inactive.svg";
import inactiveHelpcenter from "assets/icons/help-center-inactive.svg";
import inactiveMessage from "assets/icons/message-inactive.svg";
import activeMessage from "assets/icons/message-inactive.svg";
import inactiveInvoice from "assets/icons/invoice-inactive.svg";
import activeInvoice from "assets/icons/invoice-inactive.svg";
import inactiveBranch from "assets/icons/branch-inactive.svg";
import activeBranch from "assets/icons/branch-inactive.svg";
import subscriptions from "assets/icons/subscriptions.svg";
import inventoryIcon from "assets/icons/inventoryIcon.svg";
import historyIcon from "assets/icons/history_page.svg";

const currentPath = window.location.pathname;

export const topSidebarRoutes: IRoutesProps[] = [
  {
    path: "/",
    label: "Dashboard",
    icon: activeDashboard,
    inactiveIcon: inactiveDashboard,
    isActive: currentPath === "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    path: "/my-vaccinations",
    label: "My Vaccinations",
    icon: activeVaccination,
    inactiveIcon: inactiveVaccination,
    isActive: currentPath.includes("/my-vaccinations") && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    label: "History",
    path: `/history`,
    icon: historyIcon,
    inactiveIcon: historyIcon,
    isActive: currentPath === "/history",
    showLabel: true,
    hasSubRoute: true,
    shouldShow: true,
    subRoute: [
      {
        label: "Reminder History",
        path: `/history/reminder-history`,
        isActive: currentPath.includes("/history/reminder-history"),
        hasChildren: false,
      },
      {
        label: "Download History",
        path: `/history/download-history`,
        isActive: currentPath.includes("/history/download-history"),
        hasChildren: false,
      },
      {
        label: "Informed Consent History",
        path: `/history/informed-consent-history`,
        isActive: currentPath.includes("/history/informed-consent-history"),
        hasChildren: false,
      },
      {
        label: "Booking History",
        path: `/history/booking-history`,
        isActive: currentPath.includes("/history/booking-history"),
        hasChildren: false,
      },
    ],
  },
  {
    path: "/book-appointment",
    label: "Book an Appointment",
    icon: activeCalender,
    inactiveIcon: inactiveCalender,
    isActive: currentPath.includes("/book-appointment") && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: false,
  },
  {
    path: "/wallet",
    label: "Wallet",
    icon: activeWallet,
    inactiveIcon: inactiveWallet,
    isActive: currentPath.includes("/wallet") && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: false,
  },
  {
    path: "/recommendations",
    label: "Recommendations",
    icon: activeRecommendation,
    inactiveIcon: inactiveRecommendation,
    isActive: currentPath.includes("/recommendations") && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    path: "/manage-family-accounts",
    label: "Manage Family Accounts",
    icon: activeFamily,
    inactiveIcon: inactiveFamily,
    isActive:
      currentPath.includes("/manage-family-accounts") && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: false,
  },
  {
    label: "Learning & Development",
    path: `/learning-development`,
    icon: activeFamily,
    inactiveIcon: inactiveFamily,
    isActive:
      currentPath.includes(`/learning-development`) && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
];

export const bottomSidebarRoutes: IRoutesProps[] = [
  {
    path: "/settings",
    label: "Settings",
    icon: inactiveSettings,
    inactiveIcon: inactiveSettings,
    isActive: false,
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    path: "/help-center",
    label: "Help Center",
    icon: inactiveHelpcenter,
    inactiveIcon: inactiveHelpcenter,
    isActive: false,
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
];

export const getAefiSidebarRoutes = (
  dynamicSegment: string
): IRoutesProps[] => [
  {
    path: `/${dynamicSegment}/`,
    label: "Dashboard",
    icon: activeDashboard,
    inactiveIcon: inactiveDashboard,
    isActive: currentPath.includes(`/${dynamicSegment}/`),
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    path: `/${dynamicSegment}/vaccinations`,
    label: "Vaccinations",
    icon: activeVaccination,
    inactiveIcon: inactiveVaccination,
    isActive:
      currentPath.includes(`/${dynamicSegment}/vaccinations`) &&
      currentPath !== "/",
    showLabel: true,
    hasSubRoute: true,
    shouldShow: true,
    subRoute: [
      {
        label: "All Vaccinations",
        path: `/${dynamicSegment}/vaccinations/all-vaccinations`,
        isActive: currentPath === `/${dynamicSegment}/vaccinations`,
        hasChildren: false,
      },
      {
        label: "Continued Vaccinations",
        path: `/${dynamicSegment}/vaccinations/continued-vaccinations`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/vaccinations/continued-vaccinations`
        ),
        hasChildren: false,
      },
      {
        label: "All Shots",
        path: `/${dynamicSegment}/vaccinations/all-shots`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/vaccinations/all-shots`
        ),
        hasChildren: false,
      },
      {
        label: "Administered Shots",
        path: `/${dynamicSegment}/vaccinations/all-shots/administered-shots`,
        isActive:
          currentPath ===
          `/${dynamicSegment}/vaccinations/all-shots/administered-shots`,
        hasChildren: false,
      },
      {
        label: "Upcoming Shots",
        path: `/${dynamicSegment}/vaccinations/all-shots/upcoming-shots`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/vaccinations/upcoming-shots`
        ),
        hasChildren: false,
      },
      {
        label: "Due Shots",
        path: `/${dynamicSegment}/vaccinations/all-shots/due-shots`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/vaccinations/due-shots`
        ),
        hasChildren: false,
      },
      {
        label: "AEFI",
        path: `/${dynamicSegment}/vaccinations/aefi`,
        isActive: currentPath.includes(`/${dynamicSegment}/vaccinations/aefi`),
        hasChildren: true,
        children: [
          {
            label: "Dashboard",
            path: `/${dynamicSegment}/vaccinations/aefi/dashboard`,
            isActive: currentPath.includes(
              `/${dynamicSegment}/vaccinations/aefi/dashboard`
            ),
            hasChildren: false,
          },
          {
            label: "AEFI History",
            path: `/${dynamicSegment}/vaccinations/aefi/aefi-history`,
            isActive: currentPath.includes(
              `/${dynamicSegment}/vaccinations/aefi/aefi-history`
            ),
            hasChildren: false,
          },
        ],
      },
    ],
  },
  {
    label: "Users",
    path: `/${dynamicSegment}/users`,
    icon: activeFamily,
    inactiveIcon: inactiveFamily,
    isActive:
      currentPath.includes(`/${dynamicSegment}/users`) && currentPath !== "/",
    showLabel: true,
    hasSubRoute: true,
    shouldShow: true,
    subRoute: [
      {
        label: "Clients",
        path: `/${dynamicSegment}/users/clients`,
        isActive: currentPath.includes(`/${dynamicSegment}/users/clients`),
        hasChildren: true,
        children: [
          {
            label: "List Clients",
            path: `/${dynamicSegment}/users/clients/list-clients`,
            isActive: currentPath.includes(
              `/${dynamicSegment}/users/clients/list-clients`
            ),
            hasChildren: false,
          },
          {
            label: "Transfer Clients",
            path: `/${dynamicSegment}/users/clients/transfer-client`,
            isActive: currentPath.includes(
              `/${dynamicSegment}/users/clients/transfer-client`
            ),
            hasChildren: false,
          },
        ],
      },
      {
        label: "Staffs",
        path: `/${dynamicSegment}/users/staffs`,
        isActive: currentPath.includes(`/${dynamicSegment}/users/staffs`),
        hasChildren: false,
      },
    ],
  },
  {
    label: "Reminder",
    path: `/${dynamicSegment}/reminder`,
    icon: activeFamily,
    inactiveIcon: inactiveFamily,
    isActive:
      currentPath.includes(`/${dynamicSegment}/reminder`) &&
      currentPath !== "/",
    showLabel: true,
    hasSubRoute: true,
    shouldShow: true,
    subRoute: [
      {
        label: "Reminder History",
        path: `/${dynamicSegment}/reminder/reminder-history`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/reminder/reminder-history`
        ),
        hasChildren: false,
      },
      {
        label: "Manual Reminder",
        path: `/${dynamicSegment}/reminder/manual-reminder`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/reminder/manual-reminder`
        ),
        hasChildren: false,
      },
    ],
  },
  {
    label: "Reports",
    path: `/${dynamicSegment}/reports`,
    icon: activeFamily,
    inactiveIcon: inactiveFamily,
    isActive:
      currentPath.includes(`/${dynamicSegment}/reports`) && currentPath !== "/",
    showLabel: true,
    hasSubRoute: true,
    shouldShow: true,
    subRoute: [
      {
        label: "Clinical Notes",
        path: `/${dynamicSegment}/reports/clinical-notes`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/reports/clinicat-notes`
        ),
        hasChildren: false,
      },
      {
        label: "Create a laboratory report",
        path: `/${dynamicSegment}/reports/create-labroartory-test`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/reports/create-labroartory-test`
        ),
        hasChildren: false,
      },
      {
        label: "Download a record",
        path: `/${dynamicSegment}/reports/download-record`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/reports/download-record`
        ),
        hasChildren: false,
      },
      {
        label: "Download History",
        path: `/${dynamicSegment}/reports/download-history`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/reports/download-history`
        ),
        hasChildren: false,
      },
    ],
  },
  {
    path: `/${dynamicSegment}/business-wallet`,
    label: "Business Wallet",
    icon: activeWallet,
    inactiveIcon: inactiveWallet,
    isActive: currentPath.includes("/wallet") && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: false,
  },
  {
    path: `/${dynamicSegment}/messaging`,
    label: "Messaging",
    icon: activeMessage,
    inactiveIcon: inactiveMessage,
    isActive:
      currentPath === `/${dynamicSegment}/messaging` && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    path: `/${dynamicSegment}/invoice-history`,
    label: "Invoice History ",
    icon: activeInvoice,
    inactiveIcon: inactiveInvoice,
    isActive:
      currentPath === `/${dynamicSegment}/invoice-history` &&
      currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    path: `/${dynamicSegment}/branches`,
    label: "Branches ",
    icon: activeBranch,
    inactiveIcon: inactiveBranch,
    isActive:
      currentPath === `/${dynamicSegment}/branches` && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
  {
    path: `/${dynamicSegment}/business-profile`,
    label: "Business Profile ",
    icon: activeReminder,
    inactiveIcon: inactiveReminder,
    isActive:
      currentPath === `/${dynamicSegment}/business-profile` &&
      currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: false,
  },
  {
    label: "Inventory",
    path: `/${dynamicSegment}/inventory`,
    icon: activeFamily,
    inactiveIcon: inactiveFamily,
    isActive:
      currentPath.includes(`/${dynamicSegment}/inventory`) &&
      currentPath !== "/",
    showLabel: true,
    hasSubRoute: true,
    shouldShow: true,
    subRoute: [
      {
        label: "Dashboard",
        path: `/${dynamicSegment}/inventory`,
        isActive:
          currentPath.includes(`/${dynamicSegment}/inventory`) &&
          !currentPath.includes(`/${dynamicSegment}/inventory/item-list`) &&
          !currentPath.includes(`/${dynamicSegment}/inventory/supply-list`),
        hasChildren: false,
      },
      {
        label: "Item List",
        path: `/${dynamicSegment}/inventory/item-list`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/inventory/item-list`
        ),
        hasChildren: false,
      },
      {
        label: "Supply List",
        path: `/${dynamicSegment}/inventory/supply-list`,
        isActive: currentPath.includes(
          `/${dynamicSegment}/inventory/supply-list`
        ),
        hasChildren: false,
      },
      {
        label: "History",
        path: `/${dynamicSegment}/inventory/history`,
        isActive: currentPath.includes(`/${dynamicSegment}/inventory/history`),
        hasChildren: false,
      },
    ],
  },
  {
    path: `/${dynamicSegment}/subscriptions`,
    label: "Manage Subscriptions ",
    icon: subscriptions,
    inactiveIcon: subscriptions,
    isActive:
      currentPath === `/${dynamicSegment}/subscriptions` && currentPath !== "/",
    showLabel: true,
    hasSubRoute: false,
    shouldShow: true,
  },
];
